// Part 3 §3.3 — canonical six-feature "What's New" block.
// Rendered IDENTICALLY on the homepage and the About page (single source).
import { LayoutDashboard, Target, Search, FlaskConical, SlidersHorizontal, BookOpenText, ShieldCheck } from "lucide-react";

const FEATURES = [
  {
    icon: LayoutDashboard, tag: "Portfolio dashboard & risk metrics",
    body: "See net liquidation value, margin, buying power, and a Portfolio Risk Health indicator at a glance, with the current market regime shown alongside your positions. VaR, drawdown, and Monte Carlo–based risk analytics update as your portfolio changes.",
  },
  {
    icon: Target, tag: "Wheel screener",
    body: "Screen cash-secured puts, covered calls, and spreads with strikes, deltas, yields, and probability-of-non-touch shown side by side. Choose from multiple strike-selection engines — including regime-scaled delta, key-level–based, and probability-of-non-touch (PNT) approaches.",
  },
  {
    icon: Search, tag: "Scanner",
    body: "Deep-dive any ticker: full option chain with Greeks, implied volatility in historical context, the HMM regime timeline, and strategy scores across trade types — plus unusual options activity and backtest context for that name.",
  },
  {
    icon: FlaskConical, tag: "Backtest Lab",
    body: "Test a strategy against 2–5 years of real historical price data before risking capital. Option premiums are strike-aware Black-Scholes estimates (not historical chain prices). See win rate, average P&L, and max drawdown, and compare rule variants side by side.",
  },
  {
    icon: ShieldCheck, tag: "Tightened accuracy — pricing & returns",
    body: "Two accuracy upgrades: backtest premiums are now priced per-strike via Black-Scholes, with profit-target and spread-cap fixes; and screener premiums and RoR now use the executable bid price instead of the more optimistic mid. Displayed returns are deliberately conservative.",
  },
  {
    icon: SlidersHorizontal, tag: "Position management & settings",
    body: "Every open position is automatically classified — hold, take-profit zone, roll candidate, or defensive review — based on profit captured, days to expiry, distance to strike, and regime. Configure your own risk sensitivities in Settings.",
  },
  {
    icon: BookOpenText, tag: "Trade Log",
    body: "Import executed trades directly from your broker (IBKR Activity Statement, Flex Query, or .tlg formats, deduplicated automatically) or log manually. See your real equity curve, win rate by strategy, and P&L by market regime.",
  },
];

export const WhatsNewSection = ({ C }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="whats-new-grid">
    {FEATURES.map(({ icon: Icon, tag, body }) => (
      <div key={tag} className="rounded-lg p-5"
        style={{ background: C.card, border: `1px solid ${C.border}` }}
        data-testid={`whatsnew-card-${tag.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        <Icon className="w-4 h-4 mb-3" style={{ color: C.accent }} />
        <h3 className="text-sm font-bold mb-1.5" style={{ color: C.text, fontFamily: "'JetBrains Mono', monospace" }}>{tag}</h3>
        <p className="text-xs leading-relaxed" style={{ color: C.muted }}>{body}</p>
      </div>
    ))}
  </div>
);
